import React, { Component } from 'react'
import { APP_URL } from 'constants/ResourcesConstants'
import './style.styl'



const ClearbitPage = () => {
    window.location.replace(`${APP_URL}/settings2/integrations/detail/clearbit_reveal_v2`)
}

export default ClearbitPage



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/ClearbitPage/index.js